export default __webpack_public_path__ + "static/media/howto_6.2e481469.png";